module.exports = __webpack_public_path__ + "img/san-jose-hotel-6.fced77cf.jpg";